import { http } from '@/http/index'

async function deletePaidMessage(paidMessageId, threadId, messageId) {
	return http.delete(`/paid-messages/${paidMessageId}/threads/${threadId}/messages/${messageId}`)
}

export { deletePaidMessage }
